import {setUser, setModuleSettings, setAusbildungsplan} from '#services/storage'

export function pending(user) {
  return user
}

export function fulfilled() {
  return {
    isLoggedIn: false,
    isLoggingIn: false,
  }
}

export function rejected() {
  return {
    isLoggedIn: false,
    isLoggingIn: false,
  }
}

export default async function action() {
  setUser(null)
  setModuleSettings(null)
  setAusbildungsplan(null, null)
  return true
}
